import type { ComponentPropsWithRef } from "react";
import { styled } from "styled-components";

const StyledLine = styled.line`
  stroke: ${({ theme }) => theme.colors.blue};
  stroke-dasharray: 1.3rem 0.3rem;
  stroke-width: 0.15rem;
`;

const StyledKeyIssueCircle = styled.circle`
  stroke: ${({ theme }) => theme.colors.blue};
  fill: white;
  stroke-width: 0.15rem;
`;

export const ConnectingKeyIssueLine = (props: ComponentPropsWithRef<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props}>
    <StyledLine x1="0" x2="100%" y1="50%" y2="50%" />
    <StyledKeyIssueCircle r="1rem" cx="50%" cy="50%" />
  </svg>
);
